const SearchBarDefaults = {
  DISTANCE: 0,
  POSTCODE: '',
};

export default SearchBarDefaults;
